// extracted by mini-css-extract-plugin
export default {"outcome":"OutcomeWithName_outcome--Rqu","table":"OutcomeWithName_table--Ed3"};